module.exports = __webpack_public_path__ + "img/fig31.027d8e74.jpg";